
      import Upload from './upload.vue'
      import type { App, Plugin } from 'vue'

      export const UploadPlugin: Plugin = {
        install(app: App) {
          app.component('Upload', Upload)
        },
      }
      export { Upload }
      